var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAudience(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 1.34921C4.55073 1.34921 1.34921 4.55073 1.34921 8.5C1.34921 12.4493 4.55073 15.6508 8.5 15.6508C12.4493 15.6508 15.6508 12.4493 15.6508 8.5C15.6508 4.55073 12.4493 1.34921 8.5 1.34921ZM0 8.5C0 3.80558 3.80558 0 8.5 0C13.1944 0 17 3.80558 17 8.5C17 13.1944 13.1944 17 8.5 17C3.80558 17 0 13.1944 0 8.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.18987 8.87882C6.72311 8.42729 7.41981 8.14023 8.32008 8.14023C9.32108 8.14023 10.0794 8.44335 10.6426 8.93104C11.1918 9.4066 11.5081 10.0167 11.7117 10.5544C12.1028 11.5867 11.2459 12.5476 10.2758 12.5476H6.53602C5.4821 12.5476 4.62503 11.4383 5.10848 10.3892C5.34189 9.88265 5.67179 9.31752 6.18987 8.87882ZM7.00362 9.83983C6.68702 10.1079 6.45122 10.4842 6.25216 10.9162C6.22226 10.9811 6.22465 11.0629 6.28361 11.1487C6.34461 11.2375 6.44 11.2884 6.53602 11.2884H10.2758C10.3672 11.2884 10.4505 11.2435 10.5015 11.1764C10.5492 11.1136 10.5545 11.0542 10.5341 11.0004C10.3675 10.5605 10.1461 10.1668 9.81831 9.883C9.50458 9.61133 9.04667 9.39949 8.32008 9.39949C7.712 9.39949 7.30506 9.58458 7.00362 9.83983Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.32017 5.80159C7.67438 5.80159 7.15086 6.32511 7.15086 6.9709C7.15086 7.61669 7.67438 8.14021 8.32017 8.14021C8.96597 8.14021 9.48949 7.61669 9.48949 6.9709C9.48949 6.32511 8.96597 5.80159 8.32017 5.80159ZM5.8916 6.9709C5.8916 5.62964 6.97891 4.54233 8.32017 4.54233C9.66144 4.54233 10.7487 5.62964 10.7487 6.9709C10.7487 8.31216 9.66144 9.39947 8.32017 9.39947C6.97891 9.39947 5.8916 8.31216 5.8916 6.9709Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudience);
export default __webpack_public_path__ + "static/media/audience.6ba6d647b92692a62b202b8a15d8d0e1.svg";
export { ForwardRef as ReactComponent };